/* eslint-disable @typescript-eslint/no-explicit-any */

import { CLASS_ID_PACKAGE } from '../constants';
import type { RequestParams } from '../rest-service';

const packageIdentifier = 'packageIdentifier';
const classIdentifier = 'classIdentifier';
const methodIdentifier = 'methodIdentifier';
const _id = '_id';
const body = 'body';
const checkDelegation = 'checkDelegation';
const delegationUser = 'delegationUser';
const queryParams = 'queryParams';

export type BaseParams = {
  requestParams?: Partial<RequestParams>;
};

export type ClassParams =
  | {
      /**
       * package identifier
       */
      [packageIdentifier]: string;

      /**
       * class identifier.
       */
      [classIdentifier]: string;
    }
  | {
      /**
       * Class id
       */
      _classId: string;
    };

export type MethodParams = {
  [methodIdentifier]: string;
};

export type ObjectParams = {
  [_id]: string;
};

export type BodyParams = {
  [body]: any;
};

export type QueryParams = {
  [queryParams]: any;
};

export type OptionalObjectParams = {
  [_id]?: string;
};

export type DelegationParams = {
  [checkDelegation]: boolean;
  [delegationUser]: any;
};

export type OneRequestParams = BaseParams &
  Partial<ClassParams> &
  MethodParams &
  OptionalObjectParams &
  Partial<DelegationParams> &
  Partial<BodyParams> &
  Partial<QueryParams>;

/**
 * Builds the params of a request.
 * @param args - Arguments for the construction of the parameters.
 * @returns Request params.
 */
export function buildRequestParams(args: OneRequestParams): RequestParams {
  const { checkDelegation, delegationUser } = args as Partial<DelegationParams>;
  const { queryParams } = args as QueryParams;
  let { body } = args as BodyParams;

  let url = buildUrl(args);

  if (queryParams) {
    url = `${url}?${objectToQueryString(queryParams)}`;
  }

  body = checkDelegation ? { ...body, ...{ checkDelegation } } : body;
  body = delegationUser ? { ...body, ...{ delegationUser } } : body;

  return {
    ...args.requestParams,
    url,
    ...(body ? { body } : {}),
  };
}

function buildUrl(args) {
  const { packageIdentifier, classIdentifier } = args;
  const { _classId } = args;

  const { methodIdentifier } = args as MethodParams;
  const { _id } = args as ObjectParams;

  let url: string[] = [];

  if (_classId) {
    url = [CLASS_ID_PACKAGE, _classId];
  } else if (classIdentifier && packageIdentifier) {
    url = [packageIdentifier, classIdentifier];
  }

  if (methodIdentifier) {
    url = [...url, methodIdentifier];
  }

  if (_id) {
    url.push(_id);
  }
  return url.join('/');
}

function objectToQueryString(queryParams) {
  queryParams = queryParams || {};
  return Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&');
}
